"use client";

import React, { useRef } from "react";
// import { useReactToPrint } from "react-to-print";
// import { getIcon } from "@litonarefin/utils/icons";

// const getPageMargins = () => `@page { margin: 40px !important; }`;

/**
 * Print shell for the doc body.
 *
 * react-to-print needs a ref to the printed DOM node, and refs are client-only.
 * Keeping just the button + ref wrapper here lets DocContent (and the doc body
 * it renders) stay a Server Component: the markup arrives as `children`, so
 * nothing inside it is pulled into the client bundle.
 */
function PrintableDoc({ children }) {
  const componentRef = useRef(null);

  // const handlePrint = useReactToPrint({
  //   content: () => componentRef.current,
  //   pageStyle: getPageMargins,
  // });

  return (
    // Positioning context for the AISummarize button. Without it the nearest
    // positioned ancestor is the whole ListView card, so on mobile — where the
    // sidebar stacks on top — the button landed over the sidebar heading.
    <div className="jlt-relative">
      {/* AISummarize renders in DocContent, under the title — it anchors to this
          wrapper on desktop, where it floats top-right instead. */}
      {/* <button
        className="jlt-absolute jlt-right-10 jlt-top-10 jlt-text-xs jlt-font-semibold jlt-bg-white jlt-text-[#344054] jlt-py-2 jlt-px-4 jlt-rounded jlt-border jlt-border-[#D0D5DD] jlt-flex jlt-items-center jlt-gap-2"
        onClick={() => handlePrint()}
      >
        <span>Print</span>
        {getIcon("print")}
      </button> */}

      <div ref={componentRef} className="jlt-p-4 sm:jlt-p-8 xl:jlt-p-10">
        {children}
      </div>
    </div>
  );
}

export default PrintableDoc;
